import styled from 'styled-components'
import breakpoints from './breakpoints'

const Desktop = styled.div`
  display: none;
  ${breakpoints.md} {
    display: block;
  }
`
export default Desktop